// removed by extract-text-webpack-plugin
module.exports = {"block":"_3BqRoiQ867Ca6BAbSwtTEC","wrapper":"_2R9jMAVqhDE1kxqr-JNbkV","content":"_2ea28Pb72MdgRtIIbBgnQ","link":"_35DyQV6Rwb15_9UMpCmC3d","headingLink":"_28axA3FlqyWnMtfPSarvMQ","heading":"OXEMKW2EFHcyLeYCQ79Gh","image":"_2O53HD-QT2QG54M0hu_RNF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DepartmentInformationBlock/DepartmentInformationBlock.module.scss
// module id = 746
// module chunks = 0